var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraf3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276,
    height: 336,
    viewBox: "0 0 276 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "-185.182%",
    x2: "63.583%",
    y1: "85.837%",
    y2: "48.03%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2C304C"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "a",
    cx: 138,
    cy: 275,
    rx: 138,
    ry: 61
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#52577C",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4F5682",
    d: "M98 3.868l7.227-2.82c1.489-.696 2.809-1.045 3.96-1.048 1.15-.003 2.394.339 3.731 1.026l104.297 59.711c3.057 2.146 4.923 3.78 5.599 4.905.675 1.124 1.07 3.253 1.186 6.387v236.609c-.131 2.17-.527 3.812-1.186 4.923-.66 1.112-1.901 2.018-3.725 2.72-3.962.626-6.778 1.199-8.448 1.719L98 3.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353A5A",
    d: "M102.524 2.668l110.569 62.378A5.715 5.715 0 0 1 216 70.024v242.33a5.715 5.715 0 0 1-8.528 4.975l-110.57-62.502A5.715 5.715 0 0 1 94 249.852V7.646a5.715 5.715 0 0 1 8.524-4.978z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4EB",
    d: "M109.51 20.643l95.942 54.41A5.03 5.03 0 0 1 208 79.428v211.554a5.03 5.03 0 0 1-7.514 4.373l-95.941-54.519a5.03 5.03 0 0 1-2.545-4.372V25.018a5.03 5.03 0 0 1 7.51-4.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D89",
    d: "M134.985 25.488l36.473 20.859c.494.282.836.77.932 1.33l.29 1.683a1.221 1.221 0 0 1-1.814 1.264l-36.42-21.027a1.905 1.905 0 0 1-.926-1.327l-.27-1.568a1.17 1.17 0 0 1 1.735-1.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D6EE",
    d: "M82.742 98.298l85.181 48.519a2.572 2.572 0 0 1 1.3 2.242l-.12 38.416a2.572 2.572 0 0 1-3.869 2.213l-82.776-48.357a7.716 7.716 0 0 1-3.823-6.722l.262-34.096a2.572 2.572 0 0 1 3.845-2.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EA",
    d: "M68 109.078l2.418-2.269c.606-.48 1.247-.746 1.924-.799.678-.053 1.402.106 2.173.477l83.545 46.75c.625.296 1.112.775 1.46 1.44.348.663.507 1.414.476 2.253v35.47c-.09 1.309-.248 2.228-.476 2.756-.227.529-.64.937-1.238 1.225L154.753 198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M70.742 108.298l85.181 48.519a2.572 2.572 0 0 1 1.3 2.242l-.12 38.416a2.572 2.572 0 0 1-3.869 2.213l-82.776-48.357a7.716 7.716 0 0 1-3.823-6.722l.262-34.096a2.572 2.572 0 0 1 3.845-2.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D89",
    d: "M148 166v-6.706L82 122v6.447zM148 174v-6.706L82 130v6.447zM148 186v-6.706L82 142v6.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D6EE",
    d: "M118.742 44.298l85.181 48.519a2.572 2.572 0 0 1 1.3 2.242l-.12 38.416a2.572 2.572 0 0 1-3.869 2.213l-82.776-48.357a7.716 7.716 0 0 1-3.823-6.722l.262-34.096a2.572 2.572 0 0 1 3.845-2.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EA",
    d: "M106 53.078l2.418-2.269c.606-.48 1.247-.746 1.924-.799.678-.053 1.402.106 2.173.477l83.545 46.75c.625.296 1.112.775 1.46 1.44.348.663.507 1.414.476 2.253v35.47c-.09 1.309-.248 2.228-.476 2.756-.227.529-.64.937-1.238 1.225L192.753 142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M108.742 52.298l85.181 48.519a2.572 2.572 0 0 1 1.3 2.242l-.12 38.416a2.572 2.572 0 0 1-3.869 2.213l-82.776-48.357a7.716 7.716 0 0 1-3.823-6.722l.262-34.096a2.572 2.572 0 0 1 3.845-2.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D89",
    d: "M182 110v-6.706L116 66v6.447zM182 118v-6.706L116 74v6.447zM182 130v-6.706L116 86v6.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8D6EE",
    d: "M118.742 186.298l85.181 48.519a2.572 2.572 0 0 1 1.3 2.242l-.12 38.416a2.572 2.572 0 0 1-3.869 2.213l-82.776-48.357a7.716 7.716 0 0 1-3.823-6.722l.262-34.096a2.572 2.572 0 0 1 3.845-2.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EA",
    d: "M104 197.078l2.418-2.269c.606-.48 1.247-.746 1.924-.799.678-.053 1.402.106 2.173.477l83.545 46.75c.625.296 1.112.775 1.46 1.44.348.663.507 1.414.476 2.253v35.47c-.09 1.309-.248 2.228-.476 2.756-.227.529-.64.937-1.238 1.225L190.753 286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M108.742 194.298l85.181 48.519a2.572 2.572 0 0 1 1.3 2.242l-.12 38.416a2.572 2.572 0 0 1-3.869 2.213l-82.776-48.357a7.716 7.716 0 0 1-3.823-6.722l.262-34.096a2.572 2.572 0 0 1 3.845-2.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D89",
    d: "M182 252v-6.706L116 208v6.447zM182 262v-6.706L116 218v6.447zM182 272v-6.706L116 228v6.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7B8D",
    d: "M44.931 129.146c-5.247.771-7.276 7.017-6.087 18.738.481 4.744.577 8.788 2.284 11.026 1.673 2.193 5.842 2.588 12.506 1.184l.014-2.405c-2.625 1.486-3.848 1.242-3.668-.734.27-2.963 2.76-16.44 1.48-22.261-.854-3.882-3.03-5.73-6.529-5.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB6A8",
    d: "M111.208 148.867c7.638-1.565 11.71-2.293 12.218-2.183.506.11-.222.446-2.186 1.009 2.75.071 4.012.27 3.789.596-.42.613-3.06 1.944-6.325 2.422-3.265.478-5.416.74-6.868.347-.764-.208-.973-.938-.628-2.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C304D",
    d: "M38 253.739v3.604c.758.438 1.297.657 1.618.657.32 0 1.02-.5 2.095-1.498 2.156-.552 3.798-1.064 4.927-1.534 1.694-.706 3.666-2.432 3.32-2.855-.23-.282-2.882-.035-7.953.742L38 253.74zM60 267.739v3.604c.758.438 1.297.657 1.618.657.32 0 1.02-.5 2.095-1.498 2.156-.552 3.798-1.064 4.927-1.534 1.694-.706 3.666-2.432 3.32-2.855-.23-.282-2.882-.035-7.953.742L60 267.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDA1AE",
    d: "M54 195.294l-10.792 58.034c-.933.448-1.676.672-2.23.672-.555 0-1.547-.224-2.978-.672.62-19.816 1.273-34.557 1.96-44.223.405-5.709-2.166-11.23-1.058-19.036.738-5.204 2.174-8.56 4.306-10.069h8.044L54 195.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDA1AE",
    d: "M48.005 182c-.05 5.702.312 9.695 1.086 11.98 4.15 12.251 5.891 7.193 8.317 22.836.752 4.849 1.492 21.91 2.22 51.184h3.507c1.047 0 2.668-17.061 4.865-51.184L66.259 182H48.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M57.607 130.723c-8.348-3.63-13.124-3.63-14.33 0-1.808 5.447 2.073 25.38 2.073 36.666 0 11.286-2.072 8.699-3.31 14.897-1.237 6.2 26.596 3.527 26.596 0s-6.947-12.501-6.795-16.636c.176-4.791 2.441-10.125 6.795-16.002 2.082-8.377 1.78-13.517-.905-15.42-2.686-1.903-6.061-3.072-10.124-3.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB6A8",
    d: "M52 115.45l.85 12.892L59.106 130v-5.023c2.388.218 3.582-.186 3.582-1.214 0-1.027-.263-2.454-.79-4.28l2.102-.66L58.507 108 52 115.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7B8D",
    d: "M110.174 147.564c-17.907-.044-27.397.018-28.47.187-1.072.17-1.352.156-.841-.04-2.28-2.86-4.084-5-5.41-6.422-1.988-2.133-5.633-7.574-7.467-8.503-1.834-.93-5.005-2.32-3.636 5.66.543 3.169 3.23 5.006 5.076 7.132 2.804 3.23 5.085 6.06 6.165 6.811 1.194.83 2.985 1.96 5.372 3.388l30.8-5.073-1.59-3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF1B5",
    d: "M45.389 110.174c2.093-3.177 5.385-4.54 9.875-4.09 4.49.45 6.736 2.658 6.736 6.625-2.04-.124-3.06.328-3.06 1.356 0 1.541.81 5.41 0 6.822-.81 1.411-1.409 4.8-1.409 5.842 0 1.042-.733-4.13-.733-5.396s-.08-1.712-.92-1.712c-.84 0-1.716 0-.614 3.79.736 2.525-1.005 3.312-5.223 2.36 2.26 7.063 2.716 11.049 1.365 11.956-2.026 1.362 2.224 9.915-1.365 13.172-3.59 3.256-8.871-1.332-9.31-5.647-.44-4.316-1.397-9.293 0-13.318 1.396-4.025-.598-5.343 1.03-13.221 1.084-5.252 2.294-8.098 3.628-8.539z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7A6F",
    d: "M40 123.279c.153-.853 1.02-1.279 2.6-1.279 1.581 0 2.714.667 3.4 2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraf3);
export default __webpack_public_path__ + "static/media/graf-3.eb883a6bcf8e1e3701a974375ff118f6.svg";
export { ForwardRef as ReactComponent };